export default "<img class=\"rounded-circle\" [src]=\"Initial(name, size)\"/>\n";